import apiService from "./ApiService"
import { createQS } from "./Utils"

class EquipeService {
  async get(termo, idEmpresa, pagina) {
    try {
      const qs = createQS({ termo, idEmpresa, pagina })
      return await apiService.get('equipe?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('equipe/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('equipe', data)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
  
  async update(id, data) {
    try {
      return await apiService.put('equipe/' + id, data)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('equipe/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async atribuirVeiculo(idEquipe, idVeiculo) {
    try {
      return await apiService.post(`equipe/${idEquipe}/veiculo/${idVeiculo}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async listarVeiculos(idEquipe) {
    try {
      return await apiService.get(`equipe/${idEquipe}/veiculo`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async removerVeiculo(idEquipe, idVeiculo) {
    try {
      return await apiService.delete(`equipe/${idEquipe}/veiculo/${idVeiculo}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }  
}

const equipeService = new EquipeService()
export default equipeService